export const apiUrl = window.location.href.includes("localhost")
  ? "https://localhost:5001"
  //per sviluppo finchè non è online
    : "https://gigabyte-api.azurewebsites.net";
 // : "https://gigabyte-api.azurewebsites.net";
